import { defineMessages } from 'react-intl';

export const i18n: {
	statusLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	statusLabel: {
		id: 'search-page.filters.names.status',
		defaultMessage: 'Status',
		description: 'Label for filtering by status',
	},
});
